<template>
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="51" height="51" rx="10" fill="#FFF0F0" />
    <path
      d="M26 11C23.0333 11 20.1332 11.8797 17.6665 13.528C15.1997 15.1762 13.2771 17.5189 12.1418 20.2597C11.0065 23.0006 10.7094 26.0166 11.2882 28.9263C11.867 31.8361 13.2956 34.5088 15.3934 36.6066C17.4912 38.7044 20.1639 40.133 23.0736 40.7118C25.9834 41.2905 28.9994 40.9935 31.7403 39.8582C34.4811 38.7229 36.8238 36.8003 38.472 34.3335C40.1203 31.8668 41 28.9667 41 26C41 24.0302 40.612 22.0796 39.8582 20.2597C39.1044 18.4399 37.9995 16.7863 36.6066 15.3934C35.2137 14.0005 33.5601 12.8956 31.7403 12.1418C29.9204 11.388 27.9698 11 26 11ZM26 38C23.6266 38 21.3066 37.2962 19.3332 35.9776C17.3598 34.659 15.8217 32.7849 14.9135 30.5922C14.0052 28.3995 13.7676 25.9867 14.2306 23.6589C14.6936 21.3311 15.8365 19.1929 17.5147 17.5147C19.193 15.8365 21.3311 14.6936 23.6589 14.2306C25.9867 13.7676 28.3995 14.0052 30.5922 14.9134C32.7849 15.8217 34.6591 17.3598 35.9776 19.3332C37.2962 21.3065 38 23.6266 38 26C38 29.1826 36.7357 32.2348 34.4853 34.4853C32.2348 36.7357 29.1826 38 26 38Z"
      fill="url(#paint0_linear_1001_5873)"
    />
    <path
      d="M23.1494 21.8313C22.5765 19.9218 24.0064 18 26 18C27.9936 18 29.4235 19.9218 28.8506 21.8313L27.2873 27.0422C27.2171 27.2762 27.182 27.3932 27.128 27.4895C26.989 27.7371 26.7513 27.9139 26.4743 27.9759C26.3664 28 26.2443 28 26 28C25.7557 28 25.6336 28 25.5257 27.9759C25.2487 27.9139 25.011 27.7371 24.872 27.4895C24.818 27.3932 24.7829 27.2762 24.7127 27.0422L23.1494 21.8313Z"
      fill="url(#paint1_linear_1001_5873)"
    />
    <circle cx="26" cy="33" r="2" fill="url(#paint2_linear_1001_5873)" />
    <defs>
      <linearGradient
        id="paint0_linear_1001_5873"
        x1="23.8864"
        y1="2.54546"
        x2="49.8115"
        y2="9.02674"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EC4441" />
        <stop offset="1" stop-color="#FB6D6F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1001_5873"
        x1="25.4364"
        y1="15.1818"
        x2="32.4993"
        y2="16.5944"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EC4441" />
        <stop offset="1" stop-color="#FB6D6F" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1001_5873"
        x1="25.7182"
        y1="29.8727"
        x2="29.1749"
        y2="30.7369"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EC4441" />
        <stop offset="1" stop-color="#FB6D6F" />
      </linearGradient>
    </defs>
  </svg>
</template>
